module.exports =  function enableSubmitBtn(btn) {
	var btn, txt = btn.data('beforeTxt'), icon = btn.data('beforeIcon'), html, title='<span class="title">' + txt + '</span>';
	btn.removeClass('disabled').attr('disabled',false);
	if(icon !== 'undefined') {
		html = '<span class=" '+icon+'"></span> ';
	}
	btn.html(html + title);
};